import mutations from './mutations';
import {notification} from "ant-design-vue";
import {DataService} from "../../../config/dataService/dataService";

const addNotificationError = (err) => {
    notification.error({
        message: err,
    });
};

const addNotificationSuccess = (err) => {
    notification.success({
        message: err,
    });
};

const state = () => ({
    tariffs: [],
    loadingTariffs: false,
    loadingCreateTariff: false,
    loadingPatchTariff: false,
    errorTariffs: null,
    errorCreateTariff: null,
    errorPatchTariff: null,
    count: 0,
    currentPage: 1,
    pageSize: 10,
});

const actions = {
    /**
     *
     * Create tariff
     *
     * @param commit
     * @param data
     * @returns {Promise<void>}
     */
    async createSolarSimpleTariff({commit, dispatch}, data) {
        try {
            await commit('solarSimpleTariffDataCreateBegin');
            await DataService.post(`products/${data.productID}/solarsimpletariffs`, data);
            await commit('solarSimpleTariffDataCreateSuccess');
            await dispatch('getSolarSimpleTariffs', {
                id: data.productID,
                page: state.currentPage,
                pageSize: state.pageSize
            });
            addNotificationSuccess('De tarieven zijn aangemaakt.');
        } catch (err) {
            await commit('ariffDataCreateErr', err);
            addNotificationError(err?.response?.data?.message);
        }
    },
    /**
     *
     * Update tariff
     *
     * @param commit
     * @param data
     * @returns {Promise<void>}
     */
    async patchSolarSimpleTariff({commit, dispatch}, data) {
        try {
            await commit('solarSimpleTariffDataPatchBegin');
            await DataService.patch(`products/${data.productID}/solarsimpletariffs/${data.id}`, data);
            await commit('solarSimpleTariffDataPatchSuccess');
            await dispatch('getSolarSimpleTariffs', {
                id: data.productID,
                page: state.currentPage,
                pageSize: state.pageSize
            });
        } catch (err) {
            await commit('solarSimpleTariffDataPatchErr', err);
            addNotificationError(err?.response?.data?.message);
        }
    },
    /**
     *
     * Get tariffs (depending on acl)
     *
     * @param commit
     * @returns {Promise<void>}
     */
    async getSolarSimpleTariffs({commit}, data) {
        try {
            await commit('solarSimpleTariffsDataBegin');
            const response = await DataService.get(`products/${data.id}/solarsimpletariffs`, {
                page: data.page,
                pageSize: data.pageSize
            });
            await commit('solarSimpleTariffsDataSuccess', response.data);
        } catch (err) {
            await commit('solarSimpleTariffsDataErr', err);
            addNotificationError(err?.response?.data?.message);
        }
    },
    /**
     *
     * @param commit
     * @param page
     * @returns {Promise<void>}
     */
    async setCurrentPageSolarSimpleTariff({commit}, page) {
        await commit('setCurrentSolarSimplePage', page);
    },
};

export default {
    namespaced: false,
    state,
    actions,
    mutations,
};
